import FormAuth from './FormAuth';
import Layout from './Layout';
import LayoutForm from './LayoutForm';
import LessonCard from './LessonCard';
import PageNotFound from './PageNotFound';
import Presentation from './Presentation';
import Statistic from './Statistic';
import TestCard from './TestCard';
import Messaging from './Messaging';
import ResourceInfo from './ResourceInfo/ResourceInfo';
import Datepicker from './Datepicker';
import Timepicker from './Timepicker';
import Answer from './Answer';
import Catalog from './Catalog';

import UiField from './UiField';
import UiBreadcrumbs from './UiBreadcrumbs';
import UiTabs from './UiTabs';
import UiNavbar from './UiNavbar';
import UiNavbarTabs from './UiNavbarTabs';
import UiMenubar from './UiMenubar';
import UiMenu from './UiMenu';
import UiButton from './UiButton';
import UiHero from './UiHero';
import UiAvatar from './UiAvatar';

export default {
  FormAuth,
  Layout,
  LayoutForm,
  LessonCard,
  PageNotFound,
  Presentation,
  Statistic,
  TestCard,
  Messaging,
  ResourceInfo,
  Datepicker,
  Timepicker,
  Answer,
  Catalog,

  UiField,
  UiBreadcrumbs,
  UiTabs,
  UiNavbar,
  UiNavbarTabs,
  UiMenubar,
  UiMenu,
  UiButton,
  UiHero,
  UiAvatar,
};
